// import Swiper Styles
import 'swiper/css/bundle';
// import Swiper
import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  EffectFade,
} from 'swiper/modules';

// install Swiper modules
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade]);

const params = {
  loop: true,
  centeredSlides: true,
  slidesPerView: 2.2,
  spaceBetween: 16,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  speed: 1000,
  autoplay: {
    delay: 4000,
  },
  grabCursor: true,
  watchSlidesProgress: true,
};

const specialParams = {
  loop: true,
  slidesPerView: 'auto' as const,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // speed: 1000,
  // autoplay: {
  //   delay: 2000,
  // },
  grabCursor: true,
  watchSlidesProgress: true,
  centeredSlides: true,
  breakpoints: {
    768: {
      spaceBetween: 32,
    },
  },
};

const singleParams = {
  loop: true,
  centeredSlides: true,
  slidesPerView: 2.2,
  spaceBetween: 16,
  speed: 1000,
  autoplay: {
    delay: 4000,
  },
  grabCursor: true,
  watchSlidesProgress: true,
};

const singleParamsLarge = {
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 16,
  grabCursor: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

const initSwiper = () => {
  const mySwiper = new Swiper('.p-topSlider__swiper', { ...params });
  const singleSwiper = new Swiper('.singleSlider__swiper', { ...singleParams });
  const singleSwiperLarge = new Swiper('.singleSlider__swiperL', {
    ...singleParamsLarge,
  });
  const specialSwiper = new Swiper('.tempSpecialSlider__swiper', {
    ...specialParams,
  });
  const frontMvSwiper = new Swiper('.frontMvSlider__swiper', {
    ...specialParams,
  });

  if (specialSwiper) {
    //.tempSpecialSliderNum.current要素を取得
    const current = document.querySelector('.tempSpecialSliderNum.current');
    //.tempSpecialSliderNum.total要素を取得
    const total = document.querySelector('.tempSpecialSliderNum.total');
    //total.textContentにスライドの総数を代入
    if (total) {
      total.textContent = String(specialSwiper.slides.length);
    }
    //swipee-slide-activeクラスを持つ要素を取得
    const active = document.querySelector('.swiper-slide-active')!;
    //current.textContentにスライドの現在位置を代入(0から始まるので+1する)
    if (current) {
      current.textContent = (
        Number(active.getAttribute('data-swiper-slide-index')) + 1
      ).toString();
    }
    // スライドした時の処理
    specialSwiper.on('slideChange', function (this: Swiper) {
      // 現在アクティブなスライドのインデックスを取得
      const activeIndex = this.activeIndex;

      // 現在アクティブなスライド要素を取得
      const active = this.slides[activeIndex];

      // current.textContentにスライドの現在位置を代入(0から始まるので+1する)
      if (active) {
        const currentElement = document.querySelector(
          '.tempSpecialSliderNum.current'
        );
        if (currentElement) {
          currentElement.textContent = String(
            Number(active.getAttribute('data-swiper-slide-index')) + 1
          );
        }
      }
    });
  }
  if (frontMvSwiper) {
    //.frontMvSliderNum.current要素を取得
    const current = document.querySelector('.frontMvSliderNum.current');
    //.frontMvSliderNum.total要素を取得
    const total = document.querySelector('.frontMvSliderNum.total');
    //total.textContentにスライドの総数を代入
    if (total) {
      total.textContent = String(frontMvSwiper.slides.length);
    }
    //swipee-slide-activeクラスを持つ要素を取得
    const active = document.querySelector('.swiper-slide-active')!;
    //current.textContentにスライドの現在位置を代入(0から始まるので+1する)
    if (current) {
      current.textContent = (
        Number(active.getAttribute('data-swiper-slide-index')) + 1
      ).toString();
    }
    // スライドした時の処理
    frontMvSwiper.on('slideChange', function (this: Swiper) {
      // 現在アクティブなスライドのインデックスを取得
      const activeIndex = this.activeIndex;

      // 現在アクティブなスライド要素を取得
      const active = this.slides[activeIndex];

      // current.textContentにスライドの現在位置を代入(0から始まるので+1する)
      if (active) {
        const currentElement = document.querySelector(
          '.frontMvSliderNum.current'
        );
        if (currentElement) {
          currentElement.textContent = String(
            Number(active.getAttribute('data-swiper-slide-index')) + 1
          );
        }
      }
    });
  }
};

window.addEventListener('DOMContentLoaded', function () {
  initSwiper(); // ページ読み込み後に初期化
});
